// extracted by mini-css-extract-plugin
export default {"container":"webpack-concepts-Extraction-Blocks-Heading-editor-HeadingEditor-module__container"};